import escape from "lodash-es/escape";

/**
 * Handles coupon-related functionality for both the product page and product list,
 * including single-coupon and multi-coupon sidebar interactions, add-to-cart actions,
 * and coupon recommended products.
 * @namespace
 */
const responsiveCouponSidebar = {
	/**
	 * Tracks whether the images for coupon recommended products' have already been loaded.
	 * @type {Bool}
	 */
	couponProductImagesLoaded: false,
	interstitialHref: '',
	/**
	 * Used for Facebook pixel tracking.
	 * @type {Array}
	 */
	facebook_content_ids: [],
	/**
	 * Used for Facebook pixel tracking.
	 * @type {Array}
	 */
	facebook_tracked_item_ids: [],
	/**
	 * Keeps track of cart item IDs for products added to the cart.
	 * @type {Object} The cart item IDs indexed by the product IDs.
	 */
	itemsAddedToCart: {},
	/**
	 * Initializes all event listeners for the coupon recommended products' sidebar. Init is executed on document ready.
	 * @returns {undefined}
	 */
	/**
	 * Gets the main product ID from the sidebar's data attribute or falls back to the form input.
	 * @param {jQuery} $context An element inside the sidebar, used to find the closest sidebar.
	 * @returns {String|null} The product ID or null if not found.
	 */
	getMainProductId: function($context) {
		let productId = $context.data('productId');
		if (productId) {
			return String(productId);
		}
		let $sidebar = $context.closest('.couponProductsContainer');
		productId = $sidebar.data('productId');
		if (productId) {
			return String(productId);
		}
		let $form = $context.closest('.addProductForm');
		if ($form.length) {
			let $productInp = $form.find('input.mainInput');
			if ($productInp.length && '0' !== $productInp.val()) {
				return $productInp.val();
			}
		}
		let $productInp = $('.addProductForm input.mainInput');
		return ($productInp.length && '0' !== $productInp.val()) ? $productInp.val() : null;
	},
	init: function() {
		$(document.body).on('click', '.addToCartMultiCouponOffers', function(e) {
			e.stopPropagation();

			let mainItemId = responsiveCouponSidebar.getMainProductId($(this)),
				$sidebar = $('.couponProductsContainer[data-product-id="' + mainItemId + '"]');

			$sidebar.addClass('hero-active').animate({right: 0}, 400);
			sonicGlobal.overlayActivate(true);

			// If clicked from the add to cart button, add main item to cart
			if ($(this).hasClass('addProductToCard')) {
				// Mark all call to action buttons as main item already added
				$sidebar.find('.offerAction a, .offerAction button').addClass('mainItemAdded');

				if (mainItemId) {
					let warArray = {},
						$productWarrInp = $('#selected-extended-warranty-id'),
						quantity = $(this).closest('.addProductForm').find('#quantity').val() || 1;

					if ($productWarrInp.length && $productWarrInp.val() !== '0') {
						warArray[mainItemId] = $productWarrInp.val();
					}

					responsiveCouponSidebar.addItemToCart([mainItemId], warArray, quantity, true, '', mainItemId);
				}
			}
		});
		// Call to Action for Simple coupons (percent, rebate, price) when multiple offers available
		$(document.body).on('click', '.redeemSimpleCoupon', function(e) {
			e.preventDefault();
			sonicGlobal.overlayActivate(true);

			let $btn = $(this),
				offerAction = $btn.closest('.offerAction'),
				couponCode = offerAction.find('.redeem_coupon').val(),
				isMainItemAdded = $btn.hasClass('mainItemAdded'),
				mainItemId = responsiveCouponSidebar.getMainProductId($btn);

			if (!isMainItemAdded) {
				if (mainItemId) {
					let warArray = {},
						$productWarrInp = $('#selected-extended-warranty-id'),
						quantity = $('.addProductForm #quantity').val() || 1;

					if ($productWarrInp.length && $productWarrInp.val() !== '0') {
						warArray[mainItemId] = $productWarrInp.val();
					}

					responsiveCouponSidebar.addItemToCart([mainItemId], warArray, quantity, false, couponCode, mainItemId);
				}
			} else {
				// Main item already in cart, just add the coupon
				$btn.prop('disabled', true).text('Adding...');
				$.ajax({
					url: '/cart/clip',
					type: 'POST',
					dataType: 'json',
					data: {
						coupon: couponCode
					},
					success: function(response) {
						if (response.success) {
							window.location.href = '/cart';
						} else {
							$btn.prop('disabled', false).text('Add to cart');
							sonicGlobal.overlayDeactivate();
							console.error('Failed to add coupon:', response.error);
							window.location.href = '/cart';
						}
					},
					error: function() {
						$btn.prop('disabled', false).text('Add to cart');
						sonicGlobal.overlayDeactivate();
						console.error('Failed to add coupon');
					}
				});
			}
		});
		// Call to Action for BuyXgetX Coupon when multiple offers available
		$(document.body).on('click', '.addToCartRemainingQty', function(e) {
			e.preventDefault();
			sonicGlobal.overlayActivate(true);
			let mainItemId = responsiveCouponSidebar.getMainProductId($(this)),
				offerAction = $(this).closest('.offerAction'),
				isMainItemAdded = $(this).hasClass('mainItemAdded');
			if (mainItemId) {
				let itemsArray = [],
					warArray = {},
					$productWarrInp = $('#selected-extended-warranty-id'),
					dataQty = $(this).data('qty'),
					quantity = dataQty ? (isMainItemAdded ? dataQty - 1 : dataQty) : ($('.addProductForm #quantity').val() || 1),
					redeemedCode = offerAction.find('.redeem_coupon').val();

				itemsArray.push(mainItemId);

				if ($productWarrInp.length && $productWarrInp.val() !== '0') {
					warArray[mainItemId] = $productWarrInp.val();
				}

				responsiveCouponSidebar.addItemToCart(itemsArray, warArray, quantity, false, redeemedCode, mainItemId);
			}
		});
		// Call to Action for buyXgetY with y_autoload when multiple offers available
		$(document.body).on('click', '.multiCouponAutoLoadAddToCart', function(e) {
			e.preventDefault();
			let $btn = $(this),
				mainItemId = responsiveCouponSidebar.getMainProductId($btn),
				couponId = $btn.data('coupon-id'),
				couponCode = $btn.data('coupon-code'),
				productId = $btn.data('product-id'),
				isMainItemAdded = $btn.hasClass('mainItemAdded');

			if (!mainItemId) {
				return;
			}

			sonicGlobal.overlayActivate(true);
			$btn.prop('disabled', true).text('Loading...');

			// Fetch recommended products via AJAX
			$.ajax({
				url: '/product/getCouponRecommendedProducts',
				type: 'POST',
				dataType: 'json',
				data: {
					product_id: productId,
					coupon_id: couponId
				},
				success: function(response) {
					if (response.success && response.products && response.products.length > 0) {
						let itemsArray = isMainItemAdded ? [] : [mainItemId],
							warArray = {},
							$productWarrInp = $('#selected-extended-warranty-id'),
							quantity = $('.addProductForm #quantity').val() || 1;

						// Add recommended product IDs to items array
						response.products.forEach(function(product) {
							itemsArray.push(product.itemID);
						});

						if ($productWarrInp.length && $productWarrInp.val() !== '0') {
							warArray[mainItemId] = $productWarrInp.val();
						}

						responsiveCouponSidebar.addItemToCart(itemsArray, warArray, quantity, false, couponCode, mainItemId);
					} else {
						$btn.prop('disabled', false).text('Add both to cart');
						sonicGlobal.overlayDeactivate();
						console.error('No recommended products found or error:', response.message);
					}
				},
				error: function() {
					$btn.prop('disabled', false).text('Add both to cart');
					sonicGlobal.overlayDeactivate();
					console.error('Failed to fetch recommended products');
				}
			});
		});
		// Call to Action for buyXgetY without y_autoload when multiple offers available
		$(document.body).on('click', '.multiCouponSelectOtherItem', function(e) {
			e.preventDefault();
			let $btn = $(this),
				$sidebar = $btn.closest('.couponProductsContainer'),
				couponId = $btn.data('coupon-id'),
				couponCode = $btn.data('coupon-code'),
				productId = $btn.data('product-id'),
				isMainItemAdded = $btn.hasClass('mainItemAdded'),
				$offersSection = $sidebar.find('.multiCouponOffersSection'),
				$productsView = $sidebar.find('.multiCouponProductsView');

			// Add main item to cart if not already added
			if (!isMainItemAdded) {
				let mainItemId = responsiveCouponSidebar.getMainProductId($btn);
				if (mainItemId) {
					let warArray = {},
						$productWarrInp = $('#selected-extended-warranty-id'),
						quantity = $('.addProductForm #quantity').val() || 1;

					if ($productWarrInp.length && $productWarrInp.val() !== '0') {
						warArray[mainItemId] = $productWarrInp.val();
					}

					responsiveCouponSidebar.addItemToCart([mainItemId], warArray, quantity, true, couponCode, mainItemId);
				}
			} else if (couponCode) {
				// Main item already in cart, just clip the coupon
				$.ajax({
					url: '/cart/clip',
					type: 'POST',
					dataType: 'json',
					data: {
						coupon: couponCode
					}
				});
			}

			$btn.text('Loading...');

			$.ajax({
				url: '/product/getCouponRecommendedProducts',
				type: 'POST',
				dataType: 'json',
				data: {
					product_id: productId,
					coupon_id: couponId,
					page: 1
				},
				success: function(response) {
					$btn.text('Select your other item');

					if (response.success && response.products && response.products.length > 0) {
						let html = response.headerHtml || '';

						// Build product cards
						html += '<div class="couponRecommendedProducts px-2">';
						response.products.forEach(function(product) {
							html += responsiveCouponSidebar.buildMultiCouponProductCard(
								product,
								response.productDefinition,
								couponCode,
								productId
							);
						});
						html += '</div>';

						// Load more button
						if (response.moreAvailable) {
							html += '<div class="text-center my-2">'
								+ '<a class="multiCouponLoadMore px-5 btn btn-secondary d-flex mx-auto" href="javascript:;"'
								+ ' data-coupon-id="' + escape(couponId) + '"'
								+ ' data-product-id="' + escape(productId) + '"'
								+ ' data-coupon-code="' + escape(couponCode) + '"'
								+ ' data-product-definition="' + escape(response.productDefinition) + '"'
								+ ' data-page="2"'
								+ ' style="width: fit-content;">Load more</a>'
								+ '</div>';
						}

						$offersSection.hide();
						$productsView.html(html).show();

						// Sync interstitialLink href to the newly injected header
						if (responsiveCouponSidebar.interstitialHref) {
							$productsView.find('.interstitialLink').attr('href', responsiveCouponSidebar.interstitialHref);
						}
					} else {
						console.error('No recommended products found or error:', response.message);
					}
				},
				error: function() {
					$btn.text('Select your other item');
					console.error('Failed to fetch recommended products');
				}
			});
		});
		// Call to Action for BuyXGetY coupon recommended products when multiple offers available
		$(document.body).on('click', '.multiCouponRecommendedProductAddToCart', function(e) {
			e.preventDefault();

			let $btn = $(this),
				itemId = $btn.data('product-id');

			if ($btn.hasClass('added')) {
				responsiveCouponSidebar.removeItemFromCart(itemId);
				$btn.text('Add to cart');
				$btn.removeClass('added secondary-btn').addClass('primary-btn');
				$btn.addClass('remove');
			} else {
				responsiveCouponSidebar.addItemToCart([itemId], {}, {});
				$btn.html('<span class="d-flex align-items-center justify-content-center"><span class="ml-1"> Remove</span></span>');
				$btn.addClass('added secondary-btn').removeClass('primary-btn');
				$btn.removeClass('remove');
			}
		});

		// Load more for multi-coupon recommended products
		$(document.body).on('click', '.multiCouponLoadMore', function(e) {
			e.preventDefault();
			let $btn = $(this),
				couponId = $btn.data('coupon-id'),
				productId = $btn.data('product-id'),
				couponCode = $btn.data('coupon-code'),
				productDefinition = $btn.data('product-definition'),
				page = $btn.data('page');

			$btn.text('Loading...');

			$.ajax({
				url: '/product/getCouponRecommendedProducts',
				type: 'POST',
				dataType: 'json',
				data: {
					product_id: productId,
					coupon_id: couponId,
					page: page
				},
				success: function(response) {
					if (response.success && response.products && response.products.length > 0) {
						let $container = $btn.closest('.multiCouponProductsView').find('.couponRecommendedProducts');
						response.products.forEach(function(product) {
							$container.append(
								responsiveCouponSidebar.buildMultiCouponProductCard(
									product, productDefinition, couponCode, productId
								)
							);
						});

						if (response.moreAvailable) {
							$btn.data('page', page + 1);
							$btn.text('Load more');
						} else {
							$btn.closest('.text-center').remove();
						}
					} else {
						$btn.closest('.text-center').remove();
					}
				},
				error: function() {
					$btn.text('Load more');
				}
			});
		});

		$(document.body).on('click', '.multiCouponProductsBack', function(e) {
			e.preventDefault();
			let $sidebar = $(this).closest('.couponProductsContainer'),
				$offersSection = $sidebar.find('.multiCouponOffersSection'),
				$productsView = $sidebar.find('.multiCouponProductsView');

			$productsView.empty().hide();
			$offersSection.show();
		});
		// Call to Action for buyXgetY without y_autoload when single offer available
		$(document.body).on('click', '.addToCartCouponProductsLink', function(e) {
			e.stopPropagation();

			let $form = $(this).closest('.addProductForm'),
				$productInp = $form.find('input.mainInput'),
				productId = $productInp.length ? $productInp.val() : null,
				$sidebar = $('.couponProductsContainer[data-product-id="' + productId + '"]');

			responsiveCouponSidebar.getUpdatedMessageWithQty();

			$sidebar.addClass('hero-active').animate({right: 0}, 400);
			sonicGlobal.overlayActivate(true);

			responsiveCouponSidebar.openCouponRecommendedProductSidebar($form, $(this).data('couponCode'));
		});
		// Call to Action for buyXgetY with y_autoload when single offer available
		$(document.body).on('click', '.addToCartAutoLoadCouponProduct', function(e) {
			let $btn = $(this),
				couponProductIds = ($btn.data('couponProductIds') || '') + '';

			if ($('.couponProduct').length > 0 || couponProductIds) {
				e.preventDefault();
				sonicGlobal.overlayActivate(true);
				responsiveCouponSidebar.autoLoadCouponRecommendedProduct($btn);
			}
		});
		// Call to Action for BuyXGetY coupon recommended products when single offer available
		$(document.body).on('click', '.addCouponRecommendedProduct', function(event) {
			event.preventDefault();

			let $this = $(this),
				itemId = $this.data('productId');

			if ($this.hasClass('added')) {
				responsiveCouponSidebar.removeItemFromCart(itemId);
				$this.text('Add to cart');
				$this.removeClass('added secondary-btn').addClass('primary-btn');
				$this.addClass('remove');
			} else {
				responsiveCouponSidebar.addItemToCart([itemId], {}, {});
				$this.html('<span class="d-flex align-items-center justify-content-center"><span class="ml-1"> Remove</span></span>');
				$this.addClass('added secondary-btn').removeClass('primary-btn');
				$this.removeClass('remove');
			}
		});

		// Load more for single-offer coupon recommended products
		$(document.body).on('click', '.singleCouponLoadMore', function(e) {
			e.preventDefault();
			let $btn = $(this),
				couponId = $btn.data('coupon-id'),
				productId = $btn.data('product-id'),
				productDefinition = $btn.data('product-definition'),
				page = $btn.data('page');

			$btn.text('Loading...');

			$.ajax({
				url: '/product/getCouponRecommendedProducts',
				type: 'POST',
				dataType: 'json',
				data: {
					product_id: productId,
					coupon_id: couponId,
					page: page
				},
				success: function(response) {
					if (response.success && response.products && response.products.length > 0) {
						let $container = $btn.closest('.couponProductsContainer').find('.couponRecommendedProducts');
						response.products.forEach(function(product) {
							$container.append(
								responsiveCouponSidebar.buildSingleCouponProductCard(product, productDefinition)
							);
						});

						if (response.moreAvailable) {
							$btn.data('page', page + 1);
							$btn.text('Load more');
						} else {
							$btn.closest('.text-center').remove();
						}
					} else {
						$btn.closest('.text-center').remove();
					}
				},
				error: function() {
					$btn.text('Load more');
				}
			});
		});

		$(document.body).on('click', '#black-overlay, .close-hero-menu', function() {
			sonicGlobal.overlayDeactivate();
			let $activeSidebar = $('.couponProductsContainer.hero-active');
			if ($activeSidebar.length > 0) {
				$activeSidebar.removeClass('hero-active')
					.animate({right: '-50rem'}, 400);

				// Clean up multi-coupon products view on sidebar close
				let $productsView = $activeSidebar.find('.multiCouponProductsView');
				if ($productsView.length && $productsView.is(':visible')) {
					$productsView.empty().hide();
					$activeSidebar.find('.multiCouponOffersSection').show();
				}
			}
		});

		if ($('.addProductForm .addToCartCouponProductsLink').length > 0) {
			$('.addProductForm').submit(function(e) {
				e.preventDefault();
			});
		}

		if ($('.addProductForm .addToCartMultiCouponOffers').length > 0) {
			$('.addProductForm').submit(function(e) {
				e.preventDefault();
			});
		}

	},
	/**
	 * Adds an item to the cart.
	 * @param {Array} items List of product IDs to add to the cart
	 * @param {String} extended_warranty Warranty product ID to add to the cart.
	 * @param {Number} quantity
	 * @param {Bool} fromOpen TRUE if the item is being added to the cart on pop-up open.
	 * @param {String} redeemedCode Coupon code to redeem.
	 * @param {Number} mainItemId Product ID of main item
	 * @returns {undefined}
	 */
	addItemToCart: function(items, extended_warranty, quantity, fromOpen, redeemedCode, mainItemId) {
		let $loading = $('#productStatusText'),
			$spinnerBorder = $('.spinner-border'),
			$addOnsList = $('#addOnsList'),
			$warrantySpinnerBorder = $('.warranty.spinner-border'),
			$extendedOfferCards = $('#extended-offer-cards'),
			text = '',
			i = 0,
			setTimeOutId = setInterval(function() {
				i = ++i % 4;
				$loading.html(text + Array(i + 1).join('.') + Array(4 - i).join('&nbsp;'));
			}, 250),
			canSendFacebookTrackingRequest;

		if (true === fromOpen) {
			$warrantySpinnerBorder.show();
			$extendedOfferCards.addClass('d-none').removeClass('d-flex');
			if ($spinnerBorder.length) {
				$spinnerBorder.show();
				$addOnsList.addClass('d-none');
			}
		} else {
			fromOpen = false;
		}
		$.ajax({
			url: "/cart/addMultiple",
			type: "POST",
			dataType: "json",
			data: {
				format: "json",
				products: items,
				extended_warranty: extended_warranty,
				quantity: quantity,
				redeemedCode: redeemedCode,
				mainItemId: mainItemId
			},
			success: function(data) {
				if (data && data.products) {
					let allowRedirect = true;

					$.each(data.products, function(key, item) {
						let interstitialLink = $('.couponProductsContainer.hero-active').find('.interstitialLink');

						responsiveCouponSidebar.itemsAddedToCart[key] = item.cartItemID;
						if (fromOpen && item.isMainItem === true && interstitialLink.length > 0) {
							allowRedirect = false;
							let href;
							if ($('.afgProduct').length > 0) {
								href = '/cart/add-ons/item/' + item.cartItemID + '/justAdded/1';
							} else {
								href = '/cart/add-ons/item/' + item.cartItemID;
							}
							interstitialLink.attr('href', href);
							responsiveCouponSidebar.interstitialHref = href;
						}
						// Facebook pixel
						if ($.inArray(key, responsiveCouponSidebar.facebook_tracked_item_ids) > -1) {
							canSendFacebookTrackingRequest = false;
						} else {
							canSendFacebookTrackingRequest = true;
							responsiveCouponSidebar.facebook_content_ids.push(key);
							responsiveCouponSidebar.facebook_tracked_item_ids.push(key);
						}
					});

					clearInterval(setTimeOutId);
					if (fromOpen) {
						$warrantySpinnerBorder.hide();
						$extendedOfferCards.addClass('d-flex').removeClass('d-none');
						$spinnerBorder.hide();
						$addOnsList.removeClass('d-none');
						$loading.html('Item Added to Cart.');
					} else {
						$loading.html('Item Added to Cart.');
					}

					// Facebook pixel
					if (canSendFacebookTrackingRequest) {
						let facebookPixelParameters = {
							content_type: 'product',
							content_ids: responsiveCouponSidebar.facebook_content_ids
						};

						// GTM event fire
						dataLayer = dataLayer || [];
						dataLayer.push({'event': 'addedToCart', 'facebookPixelParameters': facebookPixelParameters});
					}

					if (allowRedirect) {
						let redirected = false;

						$.each(data.products, function(key, item) {
							if (item.isMainItem === true) {
								sonicGlobal.overlayDeactivate();
								if ($('.afgProduct').length > 0) {
									window.location.href = "/cart/add-ons/item/" + item.cartItemID + "/justAdded/1";
								} else {
									window.location.href = "/cart/add-ons/item/" + item.cartItemID;
								}
								redirected = true;
							}
						});

						// If main item was already in cart, redirect using its stored cart item ID
						if (!redirected && mainItemId && responsiveCouponSidebar.itemsAddedToCart[mainItemId]) {
							let cartItemID = responsiveCouponSidebar.itemsAddedToCart[mainItemId];

							sonicGlobal.overlayDeactivate();
							if ($('.afgProduct').length > 0) {
								window.location.href = "/cart/add-ons/item/" + cartItemID + "/justAdded/1";
							} else {
								window.location.href = "/cart/add-ons/item/" + cartItemID;
							}
						}
					}
				}
			},
			error: function() {
				clearInterval(setTimeOutId);
				sonicGlobal.overlayDeactivate();
			}
		});
	},
	/**
	 * Auto add coupon recommended product with main item to cart.
	 * @returns {undefined}
	 */
	autoLoadCouponRecommendedProduct: function($btn) {
		let mainItemId = responsiveCouponSidebar.getMainProductId($btn),
			couponProductIds = (($btn.data('couponProductIds') || '') + '').split(',').filter(Boolean);

		if (mainItemId) {
			let itemsArray = [mainItemId],
				warArray = {},
				$form = $btn.closest('.addProductForm'),
				$productWarrInp = $('#selected-extended-warranty-id'),
				quantity = $form.find('#quantity').val() || 1,
				redeemedCode = $btn.data('couponCode') || $('#redeem_coupon').val();

			// Product list: coupon product IDs from data attribute
			if (couponProductIds.length) {
				couponProductIds.forEach(function(id) {
					if (id && '0' !== id) {
						itemsArray.push(id);
					}
				});
			} else {
				// Product page: coupon product IDs from hidden inputs
				$form.find('input.couponProduct').each(function() {
					itemsArray.push($(this).val());
				});
			}
			if ($productWarrInp.length && $productWarrInp.val() !== '0') {
				warArray[mainItemId] = $productWarrInp.val();
			}
			responsiveCouponSidebar.addItemToCart(itemsArray, warArray, quantity, true, redeemedCode, mainItemId);
		}
	},
	/**
	 * Update message for buy 2 or more to get discount to handle the dynamic qty messaging.
	 * @returns {undefined}
	 */
	getUpdatedMessageWithQty: function() {
		if ($('.remainingQty').length > 0)
		{
			let message = $('.mainMessage').text();

			// Match the first number after common trigger words like 'add', 'buy', etc as common scenario for messages.
			let match = message.match(/\b(?:add|buy|purchase|get|order)\s+(\d+)\b/i);

			if (!match) return; // no valid number to replace

			let qtyNeededVal = $('.qtyNeeded').val();
			let targetQty = (qtyNeededVal !== undefined && qtyNeededVal !== '') ? parseInt(qtyNeededVal, 10) : (match && match[1]) ? parseInt(match[1], 10) : 0;
			let remainingQty = parseInt($('.remainingQty').val()) || 0;
			let selectedQty = parseInt($('.select-qty').val()) || 0;

			let neededQty = targetQty - (remainingQty + selectedQty);

			if (neededQty <= 0)
			{
				//supply the coupon message : x_product_x_requirement when target qty is met
				$('.mainMessage').text($('.qtyAchivedMessage').val());
			}
			else
			{
				// Replace only the original target quantity with the updated one from coupon message : x_product_more_x_requirement
				let updatedMessage = message.replace(match[1], neededQty);

				$('.mainMessage').text(updatedMessage);
				//supply this value for us to get the current value need after the click because we can only get the updated qty on cart when we refresh.
				//in the event that user close the sidebar and click the add to cart again we will be using this qty as targetQty
				$('.qtyNeeded').val(neededQty);
			}
		}
	},
	/**
	 * Populates and opens that coupon recommended product sidebar.
	 * @returns {undefined}
	 */
	openCouponRecommendedProductSidebar: function($form, couponCode) {
		responsiveCouponSidebar.showCouponRecommendedProductImages();

		let $productInp = $form ? $form.find('input.mainInput') : $('.addProductForm input.mainInput');

		if ($productInp.length) {
			let mainItemId = $productInp.val();

			if ('0' != mainItemId) {
				let itemsArray = [],
					warArray = {},
					$productWarrInp = $('#selected-extended-warranty-id'),
					quantity = $('.addProductForm #quantity').val() || 1,
					redeemedCode = couponCode || $('#redeem_coupon').val();

				itemsArray.push(mainItemId);

				if ($productWarrInp.length && $productWarrInp.val() !== '0') {
					warArray[mainItemId] = $productWarrInp.val();
				}

				responsiveCouponSidebar.addItemToCart(itemsArray, warArray, quantity, true, redeemedCode, mainItemId);
			}
		}
	},
	/**
	 * Removes an item from the cart.
	 * @param {String} item The ID of the product that should be removed.
	 * @returns {undefined}
	 */
	removeItemFromCart: function(item) {
		let $loading = $('#productStatusText'),
			text = '',
			i = 0,
			setTimeOutId = setInterval(function() {
				i = ++i % 4;
				$loading.html(text + Array(i + 1).join(".") + Array(4 - i).join("&nbsp;"));
			}, 250);

		$.ajax({
			url: "/cart/update",
			type: "POST",
			dataType: "json",
			data: {
				format: "json",
				remove_selected: true,
				delete: [responsiveCouponSidebar.itemsAddedToCart[item]]
			},
			success: function(data) {
				if (data && data.deleteCount) {
					clearInterval(setTimeOutId);

					$loading.html('Item removed from your cart');

					// Facebook pixel
					let index = responsiveCouponSidebar.facebook_content_ids.indexOf(item);

					if (index > -1) {
						responsiveCouponSidebar.facebook_content_ids.splice(index, 1);
					}
				}
			}
		});
	},
	/**
	 * Loads the coupon recommended products' images if they have not been loaded yet.
	 * @returns {undefined}
	 */
	showCouponRecommendedProductImages: function() {
		if (!responsiveCouponSidebar.couponProductImagesLoaded) {
			$('.couponProductsContainer .thumbnailImgContainer > a').each(function() {
				let link = $(this);

				link.find('img').first().attr('src', link.data('img'));
			});
			responsiveCouponSidebar.couponProductImagesLoaded = true;
		}
	},
	/**
	 * Builds HTML for a recommended product card in the multi-coupon BuyXGetY products view.
	 * @param {Object} product          Product data from AJAX response.
	 * @param {String} productDefinition 'x', 'y', or '' based on product_allocation.
	 * @param {String} couponCode       The coupon code to apply.
	 * @param {String} mainProductId    The main product ID.
	 * @returns {String} HTML string for the product card.
	 */
	buildMultiCouponProductCard: function(product, productDefinition, couponCode, mainProductId) {
		let priceHtml = '';

		if (parseFloat(product.savings) > 0) {
			priceHtml = '<p class="m-0 text-secondary" style="text-decoration: line-through; font-size: 12px;">$'
				+ escape(product.displayPrice) + '</p>'
				+ '<h4 class="m-0 custom-font-weight-600">$' + escape(product.newValue) + '</h4>'
				+ '<p class="m-0 text-success custom-font-weight-600" style="font-size: 12px;">$'
				+ escape(product.savings) + ' Savings!</p>';
		} else {
			priceHtml = '<h4 class="m-0 custom-font-weight-600">$' + escape(product.displayPrice) + '</h4>';
		}

		return '<div class="couponRecommendedProduct text-center custom-flex-1 py-2">'
			+ '<div class="thumbnailImgContainer m-auto position-relative" style="height: 106px; width: 106px;">'
			+ '<a href="' + escape(product.itemURL) + '">'
			+ '<img src="' + escape(product.itemImageURL) + '" alt="' + escape(product.displayName) + '">'
			+ '</a></div>'
			+ '<p class="productName p-0 m-0 ellipsis-1">'
			+ '<a class="text-black text-decoration-none" style="font-size: 16px;" href="'
			+ escape(product.itemURL) + '">' + escape(product.displayName) + '</a></p>'
			+ priceHtml
			+ '<a class="multiCouponRecommendedProductAddToCart btn btn-primary px-3" style="font-size: 12px;"'
			+ ' data-product-id="' + escape(product.itemID) + '"'
			+ ' data-coupon-code="' + escape(couponCode) + '"'
			+ ' data-main-product-id="' + escape(mainProductId) + '"'
			+ ' href="javascript:;" rel="nofollow">Add to cart</a>'
			+ '</div>';
	},
	/**
	 * Builds HTML for a recommended product card in the single-offer coupon sidebar.
	 * @param {Object} product           Product data from AJAX response.
	 * @param {String} productDefinition 'x', 'y', or '' based on product_allocation.
	 * @returns {String} HTML string for the product card.
	 */
	buildSingleCouponProductCard: function(product, productDefinition) {
		let priceHtml = '';

		if (parseFloat(product.savings) > 0) {
			priceHtml = '<p class="m-0 text-secondary original-display-price-text" style="text-decoration: line-through; font-size: 12px;">$'
				+ escape(product.displayPrice) + '</p>'
				+ '<h4 class="m-0 new-value-display-price-text custom-font-weight-600">$' + escape(product.newValue) + '</h4>'
				+ '<p class="m-0 text-success savings-text custom-font-weight-600" style="font-size: 12px;">$'
				+ escape(product.savings) + ' Savings!</p>';
		} else {
			priceHtml = '<h4 class="m-0 new-value-display-price-text custom-font-weight-600">$' + escape(product.displayPrice) + '</h4>';
		}

		return '<div class="couponRecommendedProduct text-center custom-flex-1 py-2">'
			+ '<div class="thumbnailImgContainer m-auto position-relative" style="height: 106px; width: 106px;">'
			+ '<a href="' + escape(product.itemURL) + '" data-img="' + escape(product.itemImageURL) + '">'
			+ '<img src="' + escape(product.itemImageURL) + '" alt="' + escape(product.displayName) + '">'
			+ '</a></div>'
			+ '<p class="productName p-0 m-0 ellipsis-1">'
			+ '<a class="text-black text-decoration-none" style="font-size: 16px;" href="'
			+ escape(product.itemURL) + '">' + escape(product.displayName) + '</a></p>'
			+ priceHtml
			+ '<a class="addCouponRecommendedProduct btn btn-primary px-3" style="font-size: 12px;"'
			+ ' data-product-id="' + escape(product.itemID) + '"'
			+ ' href="javascript:;" rel="nofollow">Add to cart</a>'
			+ '</div>';
	}
};

export default responsiveCouponSidebar;
